import { render, staticRenderFns } from "./SummonerDetails.vue?vue&type=template&id=d30048be&"
import script from "./SummonerDetails.vue?vue&type=script&lang=ts&"
export * from "./SummonerDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VAvatar,VIcon,VImg,VListItemSubtitle,VRating})
